import { Dialog } from '@angular/cdk/dialog';
import { inject } from '@angular/core';
import { CanDeactivateFn } from '@angular/router';

import { Observable, map, of, switchMap } from 'rxjs';

import { TranslocoService } from '@jsverse/transloco';

import { UnsavedChangesComponent } from './unsaved-changes.component';

export interface UnsavedChangesGuarded {
  hasUnsavedChanges: () => Observable<boolean>;
}

export const unsavedChangesRouteGuard: CanDeactivateFn<UnsavedChangesGuarded> = (component: UnsavedChangesGuarded): Observable<boolean> => {
  const translocoService = inject(TranslocoService);
  const dialog = inject(Dialog);
  return component.hasUnsavedChanges().pipe(
    switchMap((hasUnsavedChanges: boolean) => {
      if (hasUnsavedChanges) {
        const title = translocoService.translate('COMMON.COLLECTIONS.UNSAVED_CHANGES.TITLE');
        return dialog.open<boolean>(UnsavedChangesComponent, {
          disableClose: true,
          ariaLabel: title,
          data: { title },
        }).closed;
      }
      return of(!hasUnsavedChanges);
    }),
    map(Boolean),
  );
};
